<template>
  <button :style="styles">{{ propValue }}</button>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    propValue: {
      required: false,
      type: String,
      default: () => {
        return ''
      }
    },
    styles: {
      required: false,
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
